import type { ReviewQueueGroups } from '@eriko/shared-types';
import { cn } from '@eriko/ui/src/lib/utils';
import type { QueueGroup as QueueGroupKey } from '../../api/reconciliation';
import { useReconciliationStore } from '../../stores/reconciliation';

const CHIPS: Array<{
  key: QueueGroupKey;
  label: string;
  countKey?: keyof ReviewQueueGroups;
}> = [
  { key: 'all', label: 'All' },
  { key: 'suggested', label: 'Suggested', countKey: 'suggestedMatches' },
  { key: 'unmatched', label: 'Unmatched', countKey: 'unmatchedTransactions' },
  { key: 'missing-doc', label: 'Missing docs', countKey: 'missingDocuments' },
  { key: 'docs-without-payment', label: 'Docs without payment', countKey: 'documentsWithoutPayment' },
  { key: 'ambiguous-vendor', label: 'Ambiguous vendor', countKey: 'ambiguousVendor' },
  { key: 'amount-mismatch', label: 'Amount mismatch', countKey: 'amountMismatch' },
  { key: 'multiple-candidates', label: 'Multiple candidates', countKey: 'multipleCandidates' },
  { key: 'transfers', label: 'Transfers', countKey: 'transfers' },
  { key: 'auto', label: 'Matched', countKey: 'autoMatched' },
  { key: 'duplicates', label: 'Duplicates', countKey: 'possibleDuplicates' },
];

interface Props {
  counts?: Record<keyof ReviewQueueGroups, number>;
}

export function QueueFilterChips({ counts }: Props) {
  const active = useReconciliationStore((s) => s.activeFilter);
  const setFilter = useReconciliationStore((s) => s.setFilter);

  return (
    <div className="flex flex-wrap gap-2 mb-4">
      {CHIPS.map((chip) => {
        const count = chip.countKey && counts ? counts[chip.countKey] : undefined;
        return (
          <button
            key={chip.key}
            type="button"
            onClick={() => setFilter(chip.key)}
            className={cn(
              'rounded-full border px-3 py-1 text-xs font-medium transition-colors',
              active === chip.key
                ? 'border-surface-900 bg-surface-900 text-surface-0'
                : 'border-surface-200 bg-surface-0 text-surface-700 hover:border-surface-400',
            )}
          >
            {chip.label}
            {count != null && count > 0 ? ` (${count})` : ''}
          </button>
        );
      })}
    </div>
  );
}
